import { render, staticRenderFns } from "./HistoryReportDetails.vue?vue&type=template&id=5b03f5d7"
import script from "./HistoryReportDetails.vue?vue&type=script&lang=js"
export * from "./HistoryReportDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports